import { Directive, HostListener, Input } from '@angular/core';

import { trackingConstants } from './tracking.models';
import { TrackingService } from './tracking.service';

@Directive({
    selector: '[msTrackReferringActionDirective]',
    standalone: true,
})
export class TrackReferringACtionDirective {
    @Input() trackingValue?: string;
    @Input() cleanAfterTrack = false;

    constructor(private trackerService: TrackingService) {}

    @HostListener('click') onClick() {
        this.trackerService.update({ [trackingConstants.PAGE_REFERRING_ACTION]: this.trackingValue });

        if (this.cleanAfterTrack) {
            this.trackerService.triggerEventWithCleaning();
        }
    }
}
